// @flow
// ----------------------------------------------------------------------
// <copyright file="Izenda.Recipient.jsx" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//
// </copyright>
// ----------------------------------------------------------------------

import React from 'react';
import Validator from 'share/components/hoc/Izenda.Validator';
import DashboardSchedulingConstants from 'logic/data/Izenda.DashboardSchedulingConstants';
import connect from 'share/enhancers/Izenda.Connect';
import ReportSubscriptionConstants from 'logic/data/Izenda.ReportSubscriptionConstants';
import actions from './Izenda.RecipientAction';
import Select from 'share/components/controls/multiSelectBox/Izenda.Select';

const ValidatorSelect = Validator()(Select);

export default connect(actions)(function Recipient(props: any) {
  const users = props.data.getRecipients();
  const { localization } = props;
  return (
    <div className='form-group'>
      <div className='col-md-3 control-label'>{localization.getText('SUBSCRIPTION_LABEL_RECIPIENTS')}</div>
      <div className='col-md-9'>
        <div className='izenda-Recipient-Container'>
          <ValidatorSelect
            textboxMode
            multi
            searchable
            clearable={false}
            options={props.options}
            valueKey='emailAddress'
            labelKey='emailAddress'
            value={users}
            validations={DashboardSchedulingConstants.CONTRAINTS.RECIPIENTS}
            field={ReportSubscriptionConstants.FIELD_KEY.Recipients}
            onChange={props.addRecipients}
            onAddNew={props.onAddNewSelect}
          />
          <a>
            <span
              onClick={props.openPopupAddUserPopup}
              className='icon-plus'
              title={localization.getText('USER_LABEL_SELECT_USER')}
            />
          </a>
        </div>
      </div>
    </div>
  );
});



// WEBPACK FOOTER //
// ./ui/modules/Subscription/Izenda.Recipient.js